import * as React from 'react';

import { observer } from 'mobx-react';

import { Body2 } from '@estee/elc-typography';

import { textFieldClasses } from '~utils/Classes';

export interface ITextProps {
    inputLabel: string;
    name: string;
}

export const Text = observer((props: ITextProps) => {
    const { inputLabel, name } = props;

    return <Body2 className={textFieldClasses(name)} dangerouslySetInnerHTML={{ __html: inputLabel }} />;
});
